// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"5a9e6998","977":"1cd50b2d"}[chunkId] + ".chunk.js";
};